import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

// Connects to data-controller="admin--gallery-item-sorter"
export default class extends Controller {
  static targets = ["list"]
  static values = {
    reorderUrl: String
  }

  connect() {
    this.initializeSortable()
  }

  disconnect() {
    this.destroySortable()
  }

  listTargetConnected() {
    this.initializeSortable()
  }

  listTargetDisconnected() {
    this.destroySortable()
  }

  initializeSortable() {
    if (!this.hasListTarget || !this.hasReorderUrlValue) return
    this.destroySortable()

    this.sortable = new Sortable(this.listTarget, {
      animation: 150,
      handle: ".gallery-item-drag-handle",
      draggable: "[data-sortable-gallery-item-id]",
      onEnd: this.onEnd.bind(this)
    })
  }

  destroySortable() {
    if (this.sortable) this.sortable.destroy()
    this.sortable = null
  }

  async onEnd(event) {
    if (event.oldIndex === event.newIndex) return

    const orderedIds = this.currentOrderedIds()
    if (!orderedIds.length) return

    try {
      await this.persistOrder(orderedIds)
      this.renumberPositions()
    } catch (error) {
      console.error("Failed to persist gallery order", error)
      window.location.reload()
    }
  }

  currentOrderedIds() {
    return Array.from(this.listTarget.querySelectorAll("[data-sortable-gallery-item-id]"))
      .map((item) => Number(item.dataset.sortableGalleryItemId))
      .filter((id) => Number.isInteger(id) && id > 0)
  }

  async persistOrder(orderedIds) {
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
    if (!csrfToken) throw new Error("Missing CSRF token")

    const response = await fetch(this.reorderUrlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "X-CSRF-Token": csrfToken
      },
      body: JSON.stringify({
        gallery_item: {
          ordered_ids: orderedIds
        }
      })
    })

    if (!response.ok) {
      throw new Error(`Failed to persist gallery order: ${response.status}`)
    }
  }

  renumberPositions() {
    const rows = Array.from(this.listTarget.querySelectorAll("[data-sortable-gallery-item-id]"))
    rows.forEach((row, index) => {
      const position = row.querySelector("[data-gallery-order-position]")
      if (position) position.textContent = String(index + 1)
    })
  }
}
